// React imports
import React from "react";

// Custom-defined hook imports
import useCurrentUser from "../hooks/useCurrentUser";

// Custom-defined component imports
import TeacherClassroom from "../components/TeacherClassroom";
import StudentClassroom from "../components/StudentClassroom";

function Classroom() {
  // Get currently authenticated user.
  let user = null;
  user = useCurrentUser();

  // If user has not loaded yet, display loading message.
  if (!user) {
    return (
      <>
        <p>Loading...</p>
      </>
    )
  }
  // If user has loaded, show the right component.
  else {
    if (user.is_staff && !user.is_superuser) {
      return (
        <>
          <TeacherClassroom {...user} />
        </>
      )
    }
    else {
      window.location.href = "/explore";
    }
  }
}

export default Classroom;
